import { apis2 } from '.';
import http from './http';

export default class OpenServiceDeskApi {
  static listServiceDesk (param: {
    page: {
      pageNumber: number, 
      pageSize: number
    },
    showEngineerCount: boolean,
    key: string,
    serviceDeskStatus?: string
  }) {
    return http.post(apis2.OpenServiceDeskApi.listServiceDesk, param)
  }
  
  static saveOrUpdate (param: {
    id?: number | null,
    inviteEngineers: Array<any>,
    serviceDesk: {
      parentId?: string | number | null
      name: string,
      engineers: Array<any>,
      jointServiceDesks: Array<any>
      bindUserGroups?: Array<any>
    }
  }) {
    return http.post(apis2.OpenServiceDeskApi.saveOrUpdate, { parameters: param })
  }

  // [客服组支持停用]新增支持修改禁启用状态接口
  static updateActive (param: {
    id?: number | null, // 客服组id
    active: boolean, // false禁用 true启用,
  }) {
    return http.post(apis2.OpenServiceDeskApi.updateActive, { parameters: param })
  }

  // 根据ID查询详情
  static getById (param: {
    id: number
  }) {
    return http.post(apis2.OpenServiceDeskApi.getById, param)
  }

  static deleteById (param: {
    id: number
  }) {
    return http.post(apis2.OpenServiceDeskApi.deleteById, param)
  }

  static updateOrderKey (param: {
    serviceDeskIds: Array<number>,
    orderKeys: Array<number>
  }) {
    return http.post(apis2.OpenServiceDeskApi.updateOrderKey, param)
  }
}
